module.exports = __webpack_public_path__ + "static/media/hi-hat.3b1ce587.wav";